import React, { Component } from "react";
import Cookies from 'js-cookie';

class Logout extends Component {


  /**
   * Clears auth cookie and session keys when logout page is mounted.
   * @param {Object} [none] - This lifecycle method does not accept parameters.
   * @return {void} Does not return a value.
   */
  componentDidMount() {

    // Cookies.remove('user');
    // Cookies.set('auth', false);
    Cookies.remove('jwt');

    sessionStorage.removeItem('staff');
    sessionStorage.removeItem('super');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('id_s');
    sessionStorage.removeItem('admin');
    sessionStorage.removeItem('id_e');
    sessionStorage.removeItem('version');
    sessionStorage.removeItem('email');

  }

  /**
   * Stores login intention in session storage.
   * @param {Object} [none] - This method does not accept parameters.
   * @return {Promise<number>} Resolves after setting the intention value.
   */
  setIntToLogin() {
    return new Promise(function (resolve, reject) {
      sessionStorage.setItem('int', 'login');
      resolve(1);
    });
  }



  /**
   * Handles return-to-login action after logout.
   * @param {undefined} _ - Unused placeholder parameter.
   * @return {void} Does not return a value.
   */
  handleLogin = _ => {
    this.setIntToLogin()
      .then((result) => {
        console.log('redirect to login')
        if (this.props.history && typeof this.props.history.push === 'function') {
          this.props.history.push('/login');
        }
      });
  }


  /**
   * Renders the signed-out page with navigation back to login.
   * @param {Object} [none] - This render method does not accept parameters.
   * @return {JSX.Element} Logout page UI.
   */
  render() {

    return (
      <div>
        <div className='center'>

          <h1>You have been signed out.</h1>
          <h3><a href="# " onClick={() => { this.handleLogin() }}>Return to the Reserves Service.</a></h3>

        </div>
      </div>
    );
  }
}


// export { strategy }
export default Logout;
